import AddLocation from "./AddLocation";
import { AddLocationPayload, AddLocationProps } from "./AddLocation";
export default AddLocation
export type { AddLocationPayload, AddLocationProps }